import React from 'react';
import ModalShell from '../../../components/ui/ModalShell';
import CreativeBrief from './creative-brief/CreativeBrief';
import { Collab, Campaign } from '@foodfluence/shared';

interface CreativeBriefModalProps {
  isOpen: boolean;
  onClose: () => void;
  collab: Collab;
  campaign: Campaign | null;
}

const CreativeBriefModal: React.FC<CreativeBriefModalProps> = ({ isOpen, onClose, collab, campaign }) => (
  <ModalShell isOpen={isOpen} onClose={onClose} title="Creative brief" size="full">
    {campaign && <CreativeBrief collab={collab} campaign={campaign} />}
  </ModalShell>
);

export default CreativeBriefModal;
